/* eslint-disable import/prefer-default-export */
import createAction from '@clearscore/helpers.create-action';

import * as internalIdentityActionTypes from './internal-identity.types';

export const setSession = (sessionTokenObject) =>
    createAction(internalIdentityActionTypes.SET_SESSION, sessionTokenObject);

export const setConfig = (config) => createAction(internalIdentityActionTypes.SET_CONFIG, config);

export const deleteSession = () => createAction(internalIdentityActionTypes.DELETE_SESSION);
